import "../vendor/js/laguages";

const lang = $('html').attr('lang');

const phoneValidationMessages = lang === 'en' ? {
    minlength: $.validator.format("Please enter {0} digits."),
    maxlength: $.validator.format("Please enter {0} digits.")
} : {
    minlength: $.validator.format("Будь ласка, введіть {0} цифр."),
    maxlength: $.validator.format("Будь ласка, введіть {0} цифр.")
}

$(window).on("load", () => {
    setTimeout(function () {
        $('.loader').fadeOut('slow');
        $('.page-loader ').fadeOut('slow');
    }, 300);
});

$(document).ready(() => {
    AOS.init()
    setTimeout(function () {
        $('.promo-overlay').addClass('animated')
    }, 2500)
    if ($(window).width() > 1100) {
        $('.article-container').addClass('animated')

        $(".possibility-desc-track").on("beforeChange", function () {
            new Vivus('web', {duration: 400});
            new Vivus('mobile', {duration: 400});
            new Vivus('crm', {duration: 400});
            new Vivus('platform', {duration: 400});
            new Vivus('individual', {duration: 400});
            new Vivus('chat', {duration: 400});
        });

        //----------------------animation of content---------------------
//-------------------------feedback------------------------------
        $('.feedback').waypoint(function (dir) {
            if (dir === 'down') {
                $('.layer-red').addClass('animated');
                $('.layer-dark').addClass('animated');
                $('.layer-blue').addClass('animated');
            } else {
                $('.layer-red').removeClass('animated');
                $('.layer-dark').removeClass('animated');
                $('.layer-blue').removeClass('animated');
            }
        }, {
            offset: '70%'
        })
//-------------------------footer------------------------------
        $('.footer').waypoint(function (dir) {
            if (dir === 'down') {
                $('.footer-left').addClass('animated');
                $('.footer-right').addClass('animated');
            } else {
                $('.footer-left').removeClass('animated');
                $('.footer-right').removeClass('animated');
            }
        }, {
            offset: '100%'
        })
        if (document.getElementById('home_bg')) {
            //---------------------stack----------------------------------
            var waypoint = new Waypoint({
                element: $('.stack'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.stack-container').addClass('animated');
                    } else {
                        $('.stack-container').removeClass('animated');
                    }
                },
                offset: '70%'
            })
            var waypoint2 = new Waypoint({
                element: $('.stack'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.stack-container').removeClass('animated');
                    } else {
                        $('.stack-container').addClass('animated');
                    }
                },
                offset: -800
            })
            //---------------------portfolio-------------------------
            var waypoint3 = new Waypoint({
                element: $('.portfolio'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.portfolio-item-wrap').addClass('animated');
                        $('.portfolio-title').addClass('animated');
                        $('.portfolio-tabs').addClass('animated');
                    } else {
                        $('.portfolio-item-wrap').removeClass('animated');
                        $('.portfolio-title').removeClass('animated');
                        $('.portfolio-tabs').removeClass('animated');
                    }
                },
                offset: '70%'
            })
            var waypoint4 = new Waypoint({
                element: $('.portfolio'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.portfolio-item-wrap').removeClass('animated');
                        $('.portfolio-title').removeClass('animated');
                        $('.portfolio-tabs').removeClass('animated');
                    } else {
                        $('.portfolio-item-wrap').addClass('animated');
                        $('.portfolio-title').addClass('animated');
                        $('.portfolio-tabs').addClass('animated');
                    }
                },
                offset: -800
            })
            //---------------------possibility-------------------------
            var waypoint5 = new Waypoint({
                element: $('.possibility'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.possibility-desc').addClass('animated');
                        new Vivus('web', {duration: 400});
                        new Vivus('mobile', {duration: 400});
                        new Vivus('crm', {duration: 400});
                        new Vivus('platform', {duration: 400});
                        new Vivus('individual', {duration: 400});
                        new Vivus('chat', {duration: 400});
                    } else {
                        $('.possibility-desc').removeClass('animated');
                    }
                },
                offset: '70%'
            })
            var waypoint6 = new Waypoint({
                element: $('.possibility'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.possibility-desc').removeClass('animated');
                    } else {
                        $('.possibility-desc').addClass('animated');
                        new Vivus('web', {duration: 400});
                        new Vivus('mobile', {duration: 400});
                        new Vivus('crm', {duration: 400});
                        new Vivus('platform', {duration: 400});
                        new Vivus('individual', {duration: 400});
                        new Vivus('chat', {duration: 400});
                    }
                },
                offset: -700
            })
        }
        //-------------------promo---------------------
        $('.promo-container').addClass('animated')
        if (document.getElementById('home_bg')) {
            var waypoint7 = new Waypoint({
                element: $('.promo'),
                handler: function (dir) {
                    if (dir === 'down') {
                        $('.promo-container').removeClass('animated');
                    } else {
                        $('.promo-container').addClass('animated');
                    }
                },
                offset: -700
            })
        }
        //------------------header---------------------
        $('.header').addClass('animated')

        //-----------------project--------------------
        $('.project-head-title, .project-head-switcher, .project-content-desc, .project-nav-prev, .project-nav-next').addClass('animated')
        setTimeout(function () {
            $('.project-content-image-layer1, .project-content-image-layer2, .project-content-image-layer3').addClass('animated')
        }, 500)
    } else {
        $('.project-content-image-layer1, .project-content-image-layer2, .project-content-image-layer3').addClass('animated')
    }
    //------------------------popup close------------------------
    $('body').on('click', '.close-button', function () {
        $(this).parents('.popup').fadeOut('slow')
        $('body').removeClass('fixed-body')
    })
    //--------------------------------type------------------------------
    const perPage = $(window).width() > 1600 ? 16 : 15
    $('.type').click(function () {
        let slug = $(this).attr('data-slug')
        $('.tab-btn').each(function () {
            let selected = $(this).attr('data-category')
            if (selected === slug) {
                $('.tab-btn').removeClass('selected')
                $(this).addClass('selected')
                loadPortfolioData($(this).attr('data-category-id'))
                $('.pagination-button').attr('data-category-id', $(this).attr('data-category-id'))
            }
        })
    })
    if (document.getElementById('portfolio')) {
        let slug = $('.footer').attr('data-slug')
        if (!slug) {
            loadPortfolioData('')
        } else {
            $('.tab-btn').each(function () {
                let selected = $(this).attr('data-category')
                if (selected === slug) {
                    $('.tab-btn').removeClass('selected')
                    $(this).addClass('selected')
                    loadPortfolioData($(this).attr('data-category-id'))
                    $('.pagination-button').attr('data-category-id', $(this).attr('data-category-id'))
                }
            })
        }
    }
    let paginationPage = 1

    function loadPortfolioData(id) {
        $.ajax({
            type: 'GET',
            url: route('api.projects', {per_page: perPage, category_id: id}),
        }).done(function (response) {
            paginationPage = 1
            response.data.has_more_pages ? $('.portfolio-item-pagination').fadeIn('fast') : $('.portfolio-item-pagination').fadeOut('fast')
            $('.portfolio-item-container').html("");
            $('.portfolio-item-container').append(response.data.projects)
        }).fail(function (error) {
        });
    }

    $('.pagination-button').on('click', function () {
        let id = $(this).attr('data-category-id')
        $.ajax({
            type: 'GET',
            url: route('api.projects', {per_page: perPage + (paginationPage * perPage), category_id: id}),
        }).done(function (response) {
            paginationPage++
            response.data.has_more_pages ? $('.portfolio-item-pagination').fadeIn('fast') : $('.portfolio-item-pagination').fadeOut('fast')
            $('.portfolio-item-container').html("");
            $('.portfolio-item-container').append(response.data.projects)
        }).fail(function (error) {
        });
    })
    //------------------------smooth scroll------------------------
    // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    //   anchor.addEventListener('click', function (e) {
    //     e.preventDefault();
    //     $('.burger-btn, .burger-menu').removeClass('active')
    //     $('body').removeClass('fixed-body')
    //     const yOffset = -100;
    //     let element = document.querySelector(this.getAttribute('href'))
    //     let y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    //     window.scrollTo({top: y, behavior: 'smooth'});
    //   });
    // });

    if (document.getElementById('portfolio')) {
        $(document).on('click', 'a', function (event) {
            let href = $(this).attr('href')
            if (!href) {
                return;
            }
            let el = '';
            if (href.charAt(0) === '#') {
                el = href.substring(0);
            } else if (href.charAt(1) === '#') {
                el = href.substring(1);
            } else if (href.charAt(3) === '#') {
                el = href.substring(3);
            }
            if (!el) {
                return;
            }
            event.preventDefault();
            if (!(el === '#portfolio')) {
                $('html, body').animate({
                    scrollTop: $(`${el}`).offset().top - 120
                }, 500);
            } else {
                $('html, body').animate({
                    scrollTop: $(`${el}`).offset().top
                }, 500);
            }
            $('body').removeClass('fixed-body')
            $('.burger-btn').removeClass('active')
            $('.burger-menu').removeClass('active')
        });
    }


    //------------------------header------------------------
    if ($(window).scrollTop() > 10) {
        $(".header").addClass("fixed");
    }
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 80) {
            $(".header").addClass("fixed");
        } else {
            $(".header").removeClass("fixed");
        }
    });

    //------------------------portfolio filters------------------------
    $('.tab-btn').on('click', function () {
        $('.tab-btn').removeClass('selected')
        $(this).addClass('selected')
        let selected = $(this).attr('data-category-id')
        let selectedSlug = $(this).attr('data-category')
        updateQuery(selectedSlug)
        loadPortfolioData(selected)
        $('.pagination-button').attr('data-category-id', selected)
    })

    function updateQuery(slug) {
        let currentUrl = new URL(window.location.href);

        // Update the query parameter 'category' with the selected category
        currentUrl.searchParams.set("filter", slug);

        // Replace the URL without refreshing the page
        window.history.replaceState({}, document.title, currentUrl);
    }

    //-------------------career-tabs--------------------------------
    $('.career-btn').on('click', function () {
        $('.career-btn').removeClass('selected')
        $(this).addClass('selected')
        let items = $('.career-content').find('.career-item-wrap')
        let selected = $(this).attr('data-category')
        if (selected === 'all') {
            items.each(function () {
                $(this).fadeIn('slow')
            })
        } else {
            items.each(function () {
                let currentCat = $(this).attr('data-category')
                if (!(selected === currentCat)) {
                    $(this).fadeOut('fast')
                } else {
                    $(this).fadeIn('slow')
                }
            })
        }
    })

    //------------------------validations------------------------
    $('#feedback').validate({
        ignore: [],
        errorElement: 'div',
        rules: {
            name: {
                required: true,
                minlength: 2,
                maxlength: 20
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 22
            },
            mail: {
                required: true,
                email: true,
                minlength: 5,
                maxlength: 35
            },
            message: {
                required: true,
                minlength: 10,
                maxlength: 100
            }
        },
        messages: {
            name: {
                minlength: phoneValidationMessages.minlength,
                maxlength: phoneValidationMessages.maxlength,
            },
            phone: {
                minlength: phoneValidationMessages.minlength,
                maxlength: phoneValidationMessages.maxlength,
            },
        },
        submitHandler: function submitHandler(form, event) {
            event.preventDefault();
            $('.feedback-btn').addClass('load');
            $.ajax({
                type: 'POST',
                url: route('api.feedback.store'),
                data: $(form).serialize()
            }).done(function (response) {
                $('.feedback-btn').removeClass('load')
                $('.thanks').fadeIn('fast')
                $('body').addClass('fixed-body')
                document.getElementById("feedback").reset();
            }).fail(function (error) {
                $('.feedback-btn').removeClass('load')
            });
        }
    });
    $('#phone').mask('+38(999)-999-99-99')
    $('#tel').mask('+38(999)-999-99-99')
    $('#teleph').mask('+38(999)-999-99-99')

    //----------------------vacancy-form------------------------------
    $('.callback').on('click', function () {
        $('body').addClass('fixed-body')
        $('.form').fadeIn('fast')
    })
    $(document).mousedown(function (e) {
        var container = $('.form');
        if (container.has(e.target).length === 0) {
            container.fadeOut('fast');
            $('body').removeClass('fixed-body')
        }
    });
    //file
    $('#file').on('change', function (e) {
        const fileElement = $(this)
        var FileSize = e.target.files[0].size / 1024 / 1024
        if (FileSize <= 5) {
            $(this).valid()
            const fileName = e.target.files[0].name
            const filePlaceholderElement = fileElement.parents('label').find('span')
            const filePlaceholderText = filePlaceholderElement.text()
            if (filePlaceholderText) {
                filePlaceholderElement.removeClass('error-file-message')
                filePlaceholderElement.html(fileName)
                // filePlaceholderElement.next('.file-remove').fadeIn('fast')
            }
        } else {
            const filePlaceholderElement = fileElement.parents('label').find('span')
            filePlaceholderElement.text('Розмір файлу не повинен перевищувати 5 мб.')
            filePlaceholderElement.addClass('error-file-message')
            fileElement.val('')
        }
    })


    $('#vacancy-form').validate({
        ignore: [],
        errorElement: 'div',
        rules: {
            name: {
                required: true,
                minlength: 2,
                maxlength: 20
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 22
            },
            mail: {
                required: true,
                email: true,
                minlength: 5,
                maxlength: 35
            },
            telegram: {
                required: true,
                minlength: 4,
                maxlength: 30
            },
            file: {
                required: true,
            }
        },
        messages: {
            phone: {
                minlength: phoneValidationMessages.minlength,
                maxlength: phoneValidationMessages.maxlength,
            },
        },
        submitHandler: function submitHandler(form, event) {
            $('.send-form').addClass('load');
            event.preventDefault();
            var formData = new FormData()
            const userFile = document.getElementById('file').files[0]
            formData.append('career_id', $('#career_id').val())
            formData.append('internship_period_id', $('#internship_period_id').val())
            formData.append('name', $('#name').val())
            formData.append('phone', $('#tel').val())
            formData.append('telegram', $('#telegram').val())
            formData.append('mail', $('#mail').val())
            formData.append('cv', userFile)
            $.ajax({
                type: 'POST',
                processData: false,
                contentType: false,
                url: route('api.career.store'),
                data: formData
            }).done(function (response) {
                $('.send-form').removeClass('load')
                $('.popup').fadeOut('fast')
                $('.popup.thanks').fadeIn('fast')
                form.reset()
                $('.file-input-placeholder').html(lang === 'en' ? 'ATTACH CV' : 'ПРИКРІПИТИ CV')
            }).fail(function (error) {
                $('.send-form').removeClass('load')
            });
        }
    });
    //------------------------possibility slider------------------------
    $('.possibility-desc-track').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        arrows: true,
        accessibility: true,
        autoplay: true,
        draggable: false,
        autoplaySpeed: 10000,
        nextArrow: '<div class="possibility-slider-next" aria-hidden="true">' +
            '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M-4.76837e-06 13.6493L5.63692 8.00009L-4.76837e-06 2.35086L1.73538 0.615479L9.12 8.00009L1.73538 15.3847L-4.76837e-06 13.6493Z" fill="#20212E"/>' +
            '</svg>' +
            '</div>',
        prevArrow: '<div class="possibility-slider-prev" aria-hidden="true">' +
            '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path opacity="1"' +
            '   d="M9.9231 13.6493L4.28618 8.00009L9.9231 2.35086L8.18772 0.615479L0.803101 8.00009L8.18772 15.3847L9.9231 13.6493Z"' +
            'fill="#20212E"/>' +
            '</svg>' +
            ' </div>,',
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 860,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    })


    $('.project-head-switcher-item').on('click', function () {
        $('.project-head-switcher-item').removeClass('active')
        $(this).addClass('active')
        $('.project-content-image').addClass('change')
        let layer1 = $(this).attr('data-layer1')
        let layer2 = $(this).attr('data-layer2')
        let layer3 = $(this).attr('data-layer3')
        setTimeout(function () {
            $('.project-content-image-layer1').removeClass('animated')
            $('.project-content-image-layer2').removeClass('animated')
            $('.project-content-image-layer3').removeClass('animated')
            $('.project-content-image-layer1 img').prop('src', layer1)
            $('.project-content-image-layer2 img').prop('src', layer2)
            $('.project-content-image-layer3 img').prop('src', layer3)
            setTimeout(function () {
                $('.project-content-image').removeClass('change')
                $('.project-content-image-layer1').addClass('animated')
                $('.project-content-image-layer2').addClass('animated')
                $('.project-content-image-layer3').addClass('animated')
            }, 200)
        }, 300)

    })


//----------------------------burger--------------------------------
    $('.burger-btn').click(function () {
        $(this).toggleClass('active')
        $('.burger-menu').toggleClass('active')
        $('body').toggleClass('fixed-body')
    })

//--------------internship------------------------------
    $('.internship-btn').on('click', function () {
        $('.internship-btn').removeClass('selected')
        $(this).addClass('selected')
        let items = $('.internship-content-container').find('.internship-item')
        let selected = $(this).attr('data-category')
        if (selected === 'all') {
            !items.length ? $('.internship-content-container-empty').show() : $('.internship-content-container-empty').hide()
            items.each(function () {
                $(this).show()
            })
        } else {
            let filteredItems = items.filter(function() {
                return $(this).attr('data-category') === selected;
            });
            if(items.length && filteredItems.length){
                $('.internship-content-container-empty').hide()
            } else {
                $('.internship-content-container-empty').show()
            }
            items.each(function () {
                let currentCat = $(this).attr('data-category')
                if (!(selected === currentCat)) {
                    $(this).hide()
                } else {
                    $(this).show()
                }
            })
        }
    })

    //------------------------timer-------------------------
    if (document.getElementById('exam')) {
        function countdownTimeStart() {

            let countDownDate = new Date(expire_time).getTime();
// Update the count down every 1 second
            let x = setInterval(function () {
                // Get todays date and time
                let now = new Date().getTime();

                // Find the distance between now an the count down date
                let distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);
                hours < 10 ? hours = '0' + hours : hours
                minutes < 10 ? minutes = '0' + minutes : minutes
                seconds < 10 ? seconds = '0' + seconds : seconds
                // Output the result in an element with id="demo"
                $('.hours').text(hours)
                $('.minutes').text(minutes)
                $('.seconds').text(seconds)
                // If the count down is over, write some text
                let examForm = $('.exam-content')
                if (distance < 0) {
                    examForm.submit()
                }
            }, 1000);
        }

        countdownTimeStart()

    }

    //-------------------clock-----------------------

    function clock() {
        let date = new Date()
        let hourss = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours()
        let minutess = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()
        $('.map-hour').text(hourss)
        $('.map-minute').text(minutess)
    }

    setInterval(clock, 1000);

    //--------------interactive map------------------
    if (document.getElementById('map')) {
        let beforeItem = $('.pin-toggle.selected').attr('data-city')
        let beforeTexts = $('.map-head-points').find('.map-head-point')
        beforeTexts.each(function () {
            let currentCat = $(this).attr('data-city')
            if (!(beforeItem === currentCat)) {
                $(this).hide()
            } else {
                $(this).fadeIn('fast')
            }
        })
        setInterval(function () {
            let item = $('.map-filter').find('.pin-toggle.selected')
            let items = document.querySelectorAll('.pin-toggle')
            let next = item.next()
            $('.pin-toggle').removeClass('selected')
            if (next.length === 0) {
                items[0].classList.add('selected')
            } else {
                next.addClass('selected')
            }

            let texts = $('.map-head-points').find('.map-head-point')
            let selected = $('.map-filter').find('.pin-toggle.selected').attr('data-city')
            texts.each(function () {
                let currentCat = $(this).attr('data-city')
                if (!(selected === currentCat)) {
                    $(this).hide()
                } else {
                    $(this).fadeIn('fast')
                }
            })
            $('.city').removeClass('active')
            $('.pin').removeClass('active')
            let itemss = document.querySelectorAll(`.${selected}`)
            itemss.forEach(function (el) {
                el.classList.add('active')
            })

        }, 8000)
    }
    $('.pin-toggle').on('click', function () {
        $('.pin-toggle').removeClass('selected')
        $(this).addClass('selected')
        let texts = $('.map-head-points').find('.map-head-point')
        let selected = $(this).attr('data-city')
        texts.each(function () {
            let currentCat = $(this).attr('data-city')
            if (!(selected === currentCat)) {
                $(this).hide()
            } else {
                $(this).fadeIn('fast')
            }
        })
        $('.city').removeClass('active')
        $('.pin').removeClass('active')
        let items = document.querySelectorAll(`.${selected}`)
        items.forEach(function (el) {
            el.classList.add('active')
        })
    })
    //-------------team glitch-----------
    $('.team-item').hover(function () {
        let first = $(this).find('.first')
        let second = $(this).find('.second')
        let third = $(this).find('.third')
        setTimeout(function () {
            first.removeClass('active')
            second.addClass('active')
            setTimeout(function () {
                second.removeClass('active')
                third.addClass('active')
                setTimeout(function () {
                    third.removeClass('active')
                    first.addClass('active')
                }, 100)
            }, 100)
        }, 300)
    }, function () {
        let images = $(this).find('img')
        let first = $(this).find('.first')
        images.removeClass('active')
        first.addClass('active')
    })

    //-----------------test------------------------
    $('.test-btn').on('click', function () {
        $('.test-btn').removeClass('selected')
        $(this).addClass('selected')
        let selectedId = $(this).attr('data-id')
        $('#test-id').val(selectedId)
    })

    $('#test-form').validate({
        ignore: [],
        errorElement: 'div',
        rules: {
            name: {
                required: true,
                minlength: 2,
                maxlength: 40
            },
            city: {
                required: true,
                minlength: 2,
                maxlength: 35
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 22
            },
            mail: {
                required: true,
                email: true,
                minlength: 5,
                maxlength: 35
            },
            telegram: {
                required: true,
                minlength: 4,
                maxlength: 30
            },
        },
        messages: {
            phone: {
                minlength: phoneValidationMessages.minlength,
                maxlength: phoneValidationMessages.maxlength,
            },
        }
    });
//----------------------exam-----------------------

    $(window).scroll(function () {
        var scroller = $(window).scrollTop();

        if (scroller >= 350) {
            $(".exam-content-timing").addClass("fixed");
        } else {
            $(".exam-content-timing").removeClass("fixed");
        }
    });
    if (document.getElementById('vac')) {
        new Vivus('ben', {duration: 400});
        new Vivus('off', {duration: 400});
    }
})

//----------internship-selector------------

$('#internship-period').select2({
    minimumResultsForSearch: -1,
})
const careerType = {
    internships: 'internships',
};
$(document.body).on("change","#internship-period",function(){
    $.ajax({
        type: 'GET',
        url: route('api.career', {period: this.value, type: careerType.internships}),
    }).done(function (response) {
        $('.internship-content-container-wrapper').empty()
        $('.internship-content-container-wrapper').append(response.data)
        let items = $('.internship-content-container').find('.internship-item')
        let selected = $('.internship-btn.selected').attr('data-category')
        if (selected === 'all') {
            !items.length ? $('.internship-content-container-empty').show() : $('.internship-content-container-empty').hide()
            items.each(function () {
                $(this).show()
            })
        } else {
            let filteredItems = items.filter(function() {
                return $(this).attr('data-category') === selected;
            });
            if(items.length && filteredItems.length){
                $('.internship-content-container-empty').hide()
            } else {
                $('.internship-content-container-empty').show()
            }
            items.each(function () {
                let currentCat = $(this).attr('data-category')
                if (!(selected === currentCat)) {
                    $(this).hide()
                } else {
                    $(this).show()
                }
            })
        }
    }).fail(function (error) {
    })
});
